import { render, staticRenderFns } from "./EnergyTrends.vue?vue&type=template&id=3fd7a0c8&scoped=true&"
import script from "./EnergyTrends.vue?vue&type=script&lang=js&"
export * from "./EnergyTrends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd7a0c8",
  null
  
)

export default component.exports